import { render, staticRenderFns } from "./phoneConfig.vue?vue&type=template&id=ef1e01ae&scoped=true"
import script from "./phoneConfig.vue?vue&type=script&lang=js"
export * from "./phoneConfig.vue?vue&type=script&lang=js"
import style0 from "./phoneConfig.vue?vue&type=style&index=0&id=ef1e01ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e01ae",
  null
  
)

export default component.exports